module.exports = "<p-menu #menu popup=\"popup\" [styleClass]=\"'custom-options'\" [model]=\"model\"></p-menu>\n<cat-button faIcon=\"fa-bars\" (click)=\"menu.toggle($event)\"></cat-button>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/popup-menu/popup-menu.component.html
// module id = ../../../../../src/app/modules/ui-base/components/popup-menu/popup-menu.component.html
// module chunks = main